import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebaseInit';
import { getEnvironment } from '../config/firebase';

export interface SalesContactData {
    firstName: string;
    lastName: string;
    email: string;
    company: string;
    jobTitle?: string;
    message: string;
    source?: string;
}

/**
 * Service for handling sales contact form submissions
 * Uses Firebase Functions to save data to Firebase Realtime Database
 * Uses emulator for localhost development, production for deployed apps
 * Does not expose Firebase connection details - uses pre-initialized functions instance
 */
export class SalesService {
    /**
     * Save a sales contact form submission via Firebase Function
     * @param data - The contact form data
     * @returns Promise with the result from the function
     */
    static async saveSalesContact(data: SalesContactData): Promise<any> {
        try {
            // Get environment from hostname detection
            const environment = getEnvironment();

            // Use pre-initialized functions instance (connected to emulator in dev, production in prod)
            const salesData = {
                ...data,
                source: data.source || 'contact-sales-page',
                status: 'new',
                environment, // Required by the function
            };

            // Call Firebase Function to save sales contact
            const saveSalesContactFn = httpsCallable(functions, 'saveSalesContact');
            const result = await saveSalesContactFn(salesData);

            console.log('[SalesService] Sales contact saved successfully via function');
            return result.data;
        } catch (error: any) {
            console.error('[SalesService] Error saving sales contact:', error);
            throw new Error(`Failed to save contact form: ${error.message || 'Unknown error'}`);
        }
    }
}

